import { render } from "./TabShownotes.vue?vue&type=template&id=2e599e9e"
import script from "./TabShownotes.vue?vue&type=script&lang=js"
export * from "./TabShownotes.vue?vue&type=script&lang=js"
script.render = render

export default script